export default __webpack_public_path__ + "static/media/img4.9b745391.png";